import { LienPriorityType } from 'constants/loanApplication';

export const EXPANDED_ROW_COUNT = 9;
export const COLLAPSED_ROW_COUNT = 4;

export const LIEN_PRIORITY_LABEL = {
  [LienPriorityType.FIRST]: '1st lien',
  [LienPriorityType.SECOND]: '2nd lien',
  [LienPriorityType.THIRD]: '3rd lien',
  [LienPriorityType.FOURTH]: '4th lien',
  [LienPriorityType.OTHER]: 'Other lien',
};
